import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {errorMessages} from '../../../core/error/errorMessages';
import {AgendaEventDataService} from './impl/service/ngrx/agendaEventData.service';
import {AgendaEventRepository} from './impl/service/ngrx/agenda-event.repository';

@NgModule()
export class AgendaEventModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                agendaEventDataService: AgendaEventDataService,
                repository: AgendaEventRepository,
    ) {

        entityDataService.registerServices({
            AgendaEvent: agendaEventDataService,
        });

        entityServices.registerEntityCollectionServices({
            AgendaEvent: repository,
        });

        errorMessages.set('AGENDA_EVENT_SAVE_ONLY_ONE_GOOGLE_CALENDAR_ALLOWED', 'Le rendez-vous ne peut être lié qu\'à un seul calendrier Google.');
        errorMessages.set('AGENDA_EVENT_SAVE_END_BEFORE_DATE', 'La date de début doit être inférieure à la date de fin');
        errorMessages.set('AGENDA_EVEN_ONLINE_FORM_ADD_NO_PARTNER', 'Le rendez-vous doit concerné un partenaire pour pouvoir avoir des formulaires en ligne');
        errorMessages.set('AGENDA_EVEN_ONLINE_FORM_ADD_ONLINE_FORM_ALREADY_EXISTS', 'Un formulaire en ligne de ce type existe déjà pour ce rendez-vous');
        errorMessages.set('AGENDA_EVEN_SAVE_AUTOGENERATED_LABEL_NO_OPTION_SELECTED', 'Veuillez sélectionner au moins une option pour la génération automatique du titre');

    }
}
